module.exports = __webpack_public_path__ + "static/media/ic_db_account.07ea0fa5.svg";